import React from 'react';
import { FieldSelect } from '../../components';

const CustomSelectField = props => {
  const { id, name, label, placeholder, options, validate } = props;

  return options ? (
    <FieldSelect name={name} id={id} label={label} validate={validate}>
      <option disabled value="">
        {placeholder}
      </option>
      {options.map(c => (
        <option key={c.key} value={c.key}>
          {c.label}
        </option>
      ))}
    </FieldSelect>
  ) : null;
};

export default CustomSelectField;
